export default __webpack_public_path__ + "static/media/5-100.873e2f7e.jpg";